import parse from "html-react-parser";

function ArticleComponent({
  data,
  id,
  hs,
  hf,
  ts,
  tf,
  type,
  logow,
  logoh,
  read,
}) {
  let desL = data?.Content && parse(data?.Content?.slice(0, 300));
  let desM = data?.Content && parse(data?.Content);
  let title = data?.Title && parse(data?.Title);
  let ed = data?.Event_Description && parse(data?.Event_Description);
  let ed_excerpt =
    data?.Event_Description && parse(data?.Event_Description?.slice(0, 300));
  let url = `https://smorgborg.org/view/${id}`;

  const newDateOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };

  return (
    <>
      {type && type === "event" ? (
        <div style={{ marginTop: "8px", marginBottom: "8px", width: "100%" }}>
          <div style={{ textAlign: "left" }}>
            <p
              style={{
                fontSize: hs,
                fontFamily: hf,
                textAlign: "left",
              }}
            >
              <a
                href={data?.Event_Website}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                {data?.Event_Name}
              </a>
            </p>

            {logow && logoh && data?.Featured_Photo ? (
              <div>
                <a
                  href={data?.Event_Website}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={data?.Featured_Photo}
                    width={logow}
                    height={logoh}
                    style={{
                      maxHeight: "600px",
                      maxWidth: "600px",
                    }}
                    alt="feature"
                  />
                </a>
              </div>
            ) : data?.Featured_Photo ? (
              <div style={{ textAlign: "center" }}>
                <img
                  src={data?.Featured_Photo}
                  alt="feature"
                  style={{ maxHeight: "600px", maxWidth: "600px" }}
                />
              </div>
            ) : null}

            <div style={{ textAlign: "left", fontSize: ts, fontFamily: tf }}>
              <p>
                {data?.Event_Start_Date.toLocaleString("en-US", newDateOptions)}
              </p>
              <p style={{ textAlign: "left" }}>
                {read ? ed_excerpt : ed}
                {read && (
                  <a
                    href={data?.Event_Website}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    ...Read more
                  </a>
                )}
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div
          style={{
            marginTop: "8px",
            marginBottom: "8px",
            width: "100%",
            textAlign: "left",
          }}
        >
          <div>
            <p style={{ fontSize: hs, fontFamily: hf }}>
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", marginBottom: "6px" }}
              >
                {title}
              </a>
            </p>

            {logow && logoh && data?.Featured_Photo ? (
              <div style={{ textAlign: "center", margin: "0px auto" }}>
                <a href={url} target="_blank" rel="noopener noreferrer">
                  <img
                    src={data?.Featured_Photo}
                    style={{
                      height: "auto",
                      maxHeight: "600px",
                      maxWidth: "600px",
                      width: "100%",
                      objectFit: "contain",
                    }}
                    alt="feature"
                  />
                </a>
              </div>
            ) : data?.Featured_Photo ? (
              <div style={{ textAlign: "center" }}>
                <a href={url} target="_blank" rel="noopener noreferrer">
                  <img
                    src={data?.Featured_Photo}
                    alt="feature"
                    style={{
                      height: "auto",
                      maxHeight: "600px",
                      maxWidth: "600px",
                      width: "100%",
                      objectFit: "contain",
                    }}
                  />
                </a>
              </div>
            ) : null}

            <div
              style={{
                fontSize: ts,
                fontFamily: tf,
                maxWidth: "600px",
                padding: "0 auto",
                margin: 0,
              }}
            >
              <style>
                {`
                  div p {
                    margin: 0 !important;
                  }
                  p {
                    margin: 0 !important;
                  }
                  figure img {
                    display: inline-block;
                    margin: 0 auto; /* Centers the image horizontally */
                    max-width: 100%; /* Ensure the image doesn't overflow */
                  }
                `}
              </style>
              {read ? desL : desM}
              {read && (
                <a
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none" }}
                >
                  ..... Read more
                </a>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ArticleComponent;
